import { LeaderboardState } from '../reducers/leaderboard.reducer';

export const getUsers = (state: LeaderboardState) => state.users;
export const getLoading = (state: LeaderboardState) => state.loading;
export const getCountryLeaderboardsData = (state: LeaderboardState) => state.countryLeaderboardsData;
export const getCountryLeaderboard = (state: LeaderboardState) => state.countryLeaderboard;
export const getCountryLeaderboardsLoading = (state: LeaderboardState) => state.countryLoading;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/selectors/leaderboard.selector.ts